import { useContext } from "react"
import { SideBarContextValues } from "../../contexts/SidebarContext"

const useSidebarContext = () => {
  const data = useContext(SideBarContextValues)
  return data
}

export default useSidebarContext
